import type { CommunityDetail } from '@/api/types'

/**
 * Phase 19: banner on /c/:slug — uses the community's accent gradient and renders name +
 * description + stat row above the sticky Browse toolbar.
 */
export const CommunityHero = ({ community }: { community: CommunityDetail }) => {
  const accent = community.accentColor ?? '#6366F1'
  return (
    <div
      className="-mx-4 mb-4 px-4 py-8 text-white sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
      style={{
        background: `linear-gradient(135deg, ${accent}, ${accent}cc)`,
      }}
    >
      <div className="mx-auto max-w-5xl space-y-2">
        <div className="flex items-baseline gap-3">
          <h1 className="text-3xl font-bold tracking-tight">{community.name}</h1>
          <span className="text-sm opacity-80">/c/{community.slug}</span>
        </div>
        {community.description && (
          <p className="max-w-prose text-sm opacity-95">{community.description}</p>
        )}
        <div className="flex gap-4 pt-1 text-xs opacity-90">
          <span>
            {community.memberCount} {community.memberCount === 1 ? 'member' : 'members'}
          </span>
          <span>
            {community.projectCount} {community.projectCount === 1 ? 'project' : 'projects'}
          </span>
        </div>
      </div>
    </div>
  )
}
